var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{staticClass:"chartjs-render-monitor",staticStyle:{"width":"904px","height":"676px","display":"block"},attrs:{"id":"source-chart","width":"813","height":"608"}})}
var staticRenderFns = []

export { render, staticRenderFns }